var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-xl-12" }, [
      _vm.mandaten.length > 0
        ? _c(
            "div",
            { staticClass: "stack" },
            [
              _c("h5", { staticClass: "header-title pb-2 mt-0" }, [
                _vm._v(
                  "\n        Mandaten, vergoedingen, ... (voor deze opdracht)\n      "
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.mandaten, function(mandaat, index) {
                return _c(
                  "div",
                  [
                    _c(
                      "h6",
                      { key: "mandaat-h6-title-" + index, staticClass: "mb-2" },
                      [_vm._v("\n          Mandaat/vergoeding\n        ")]
                    ),
                    _vm._v(" "),
                    mandaat.einddatum
                      ? [
                          mandaat.begindatum === mandaat.einddatum
                            ? [
                                _c("list-item", {
                                  key: "mandaat-begindatum-li-" + index,
                                  attrs: {
                                    title: "Één dag",
                                    text: mandaat.begindatum
                                  }
                                })
                              ]
                            : [
                                mandaat.begindatum
                                  ? _c("list-item", {
                                      key: "mandaat-begindatum-li-" + index,
                                      attrs: {
                                        title: "Begindatum",
                                        text: mandaat.begindatum
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("list-item", {
                                  key: "mandaat-einddatum-li-" + index,
                                  attrs: {
                                    title: "Einddatum",
                                    text: mandaat.einddatum
                                  }
                                })
                              ]
                        ]
                      : [
                          mandaat.begindatum
                            ? _c("list-item", {
                                key: "mandaat-periode-li-" + index,
                                attrs: {
                                  title: "Periode",
                                  text: "Vanaf " + mandaat.begindatum
                                }
                              })
                            : _vm._e()
                        ],
                    _vm._v(" "),
                    mandaat.omschrijving
                      ? _c("list-item", {
                          key: "list-item-mandaat-omschrijving-" + index,
                          attrs: {
                            title: "Omschrijving",
                            text: mandaat.omschrijving
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    mandaat.ambt
                      ? _c("list-item", {
                          key: "list-item-mandaat-ambt-" + index,
                          attrs: { title: "Ambt", text: mandaat.ambt }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    mandaat.functie
                      ? _c("list-item", {
                          key: "list-item-mandaat-functie-" + index,
                          attrs: {
                            title: "Functie-omschrijving",
                            text: mandaat.functie
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    mandaat.nvs
                      ? _c("list-item", {
                          key: "list-item-mandaat-nvs-" + index,
                          attrs: {
                            title: "Niet-verworven salarisschaal",
                            text: mandaat.nvs
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    mandaat.bedrag
                      ? _c("list-item", {
                          key: "list-item-mandaat-bedrag-" + index,
                          attrs: {
                            title: "Bedrag",
                            text:
                              _vm.moneyNotation(mandaat.bedrag) +
                              " " +
                              _vm.suffixForMandaatBedrag(mandaat)
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mandaten.length < index
                      ? _c("hr", {
                          key: "mandaat-divider-" + index,
                          staticClass: "mt-2"
                        })
                      : _vm._e()
                  ],
                  2
                )
              })
            ],
            2
          )
        : _c("div", { staticClass: "text-center" }, [
            _c("h6", [_vm._v("Geen mandaten voor deze opdracht")])
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }